import { AppState } from "Redux/definitions/AppState";
import { defaultState, StateWeatherData} from "./WeatherData.reducer";

type CompleteState = AppState & { WeatherData: StateWeatherData };

export const getWeatherData = (state: CompleteState) => state.WeatherData || defaultState;

export const getWeatherDataIsLoading = (state: CompleteState) => getWeatherData(state).isLoading;
export const getWeatherDataWeatherData = (state: CompleteState) => getWeatherData(state).weatherData;

export default {
	//nothing
};
